import Swal from 'sweetalert2';
import axios from 'axios';
import iconVerified from './icon-verified.png';
import style from './main.css';
import font from './font.css';

const PROOF_API_URL = 'https://us-central1-istackmanila-playground.cloudfunctions.net/Sproof';
const DEFAULT_COUNT = 590;
const DEFAULT_STARTDATE = 'yesterday';
const PERCENTAGE = 0.95;
const DEFAULT_VIEW_ID = 'AWC';

const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-start',
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  onOpen: toast => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

window.SPROOF = function(
  options = {
    viewersName: 'Marketers',
    url: '/europe',
    startDate: DEFAULT_STARTDATE,
    defaultValue: DEFAULT_COUNT,
    viewId: DEFAULT_VIEW_ID
  }
) {
  const url = options.url || '/europe/';
  const viewersName = options.viewersName || 'Marketers';
  const startDate = options.startDate || DEFAULT_STARTDATE;
  const defaultValue = options.defaultValue || DEFAULT_COUNT;
  const viewId = options.viewId || DEFAULT_VIEW_ID;

  axios
    .post(PROOF_API_URL, { url: url, start_date: startDate, view_id: viewId })
    .then(response => {
      // console.log(response.data);
      let origValue = parseInt(response.data.data.count);
      let totalViews = origValue > defaultValue ? origValue : Math.floor(Math.random() * defaultValue) + (defaultValue - 50);
      let startTotal = Math.floor(totalViews * PERCENTAGE)
        ? Math.floor(totalViews * PERCENTAGE)
        : 1;

      Toast.fire({
        html: `
          <style>${font}</style>
          <style>${style}</style>
          <div class="sproof-popup">
            <aside> 
              <img src='${iconVerified}' class="icon-verified" width="33" height="40" alt="verified"/>
            </aside>
            <section>
              <p><strong id='sproof-total-views'>${startTotal}</strong> <strong>${viewersName}</strong> viewed this site in the past 24hrs.</p>
              <small>Verified Google Analytics Statistics</small>
            </section>
          </div>
        `
      });

      let runOdometer = setInterval(odometer, 1);

      function odometer() {
        const totalViewsEl = document.getElementById('sproof-total-views');
        const totalViewsElCount = totalViewsEl ? totalViewsEl.innerHTML : 0;
        if (totalViewsEl && (parseInt(totalViewsElCount) < totalViews)) {
          totalViewsEl.innerHTML = parseInt(totalViewsElCount) + 1;
        } else {
          clearInterval(runOdometer);
        }
      }
    });
};

if (typeof window.SPROOF_READY == 'function') {
  window.SPROOF_READY(window.SPROOF);
}
